import { useEffect, useState } from 'react';

const DEFAULT_BREAKPOINT = 768;

const detectMobile = (breakpoint) => {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') {
    return false;
  }

  const mediaQuery = window.matchMedia?.(`(max-width: ${breakpoint}px)`);
  const isNarrowViewport = mediaQuery ? mediaQuery.matches : window.innerWidth <= breakpoint;
  const userAgent = navigator.userAgent || '';
  const isMobileAgent = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);

  return isMobileAgent || isNarrowViewport;
};

export const useIsMobileViewport = (breakpoint = DEFAULT_BREAKPOINT) => {
  const [isMobile, setIsMobile] = useState(() => detectMobile(breakpoint));

  useEffect(() => {
    if (typeof window === 'undefined') {
      return undefined;
    }

    const handleResize = () => setIsMobile(detectMobile(breakpoint));

    handleResize();
    window.addEventListener('resize', handleResize);
    window.addEventListener('orientationchange', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('orientationchange', handleResize);
    };
  }, [breakpoint]);

  return isMobile;
};

export default useIsMobileViewport;
